import { useRef } from "react";
import { TextureLoader, Uniform } from "three";
import { useLoader, useFrame } from "@react-three/fiber";

import vertexShader from "../../shaders/tvnoise/vertex.glsl";
import fragmentShader from "../../shaders/tvnoise/fragment.glsl";

export default function TvScreen(props) {
  const planeRef = useRef();
  const buttonRef = useRef();

  // Load the button texture (your custom button image)
  const buttonTexture = useLoader(TextureLoader, "./Textures/home.png");

  useFrame(({ clock }) => {
    planeRef.current.material.uniforms.uTime.value = clock.getElapsedTime();

    if (buttonRef.current?.material) {
      buttonRef.current.material.opacity = props.opacity;
    }
  });

  const shaderMaterial = {
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
    uniforms: {
      uTime: new Uniform(0),
      uProgress: new Uniform(props.progress),
    },
  };

  const handleClick = () => {
    if (props.opacity > 0.9) {
      window.open("https://home-for-you.vercel.app/", "_blank");
    }
  };

  return (
    <>
      <ambientLight intensity={1} />

      {/* TV Noise Shader Background */}
      <mesh position={[0.61, 2.35, -3.49]} ref={planeRef}>
        <planeGeometry args={[0.65, 0.45]} />
        <shaderMaterial attach="material" args={[shaderMaterial]} />
      </mesh>

      {/* Centered Single Button */}
      <mesh
        ref={buttonRef}
        position={[0.61, 2.35, -3.48]} // center of TV
        scale={[0.25, 0.25, 0.25]} // adjust button size
        onClick={handleClick}
      >
        <planeGeometry />
        <meshBasicMaterial map={buttonTexture} transparent />
      </mesh>
    </>
  );
}
